import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const Header = () => {

  const favitem = useSelector(state => state.favorite.totalQuality)
  

  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
  return (
    
      <div className="bg-white fixed top-0 left-0 z-10 w-full">
        <div className="border py-3 px-6">
          <div className="flex justify-between">
            <div className="flex items-center">
              <Link to='/'>
              <img src={logo} className="w-20" />
              </Link>
            </div>

            <div className="ml-6 flex flex-1 gap-x-3 hidden lg:block">
              <input
                type="text"
                className="w-full rounded-md border border-[#DDE2E4] px-3 py-2 text-sm"
              />
            </div>

            <div className="ml-2 flex">
              <Link to='/myfavorite' className="flex cursor-pointer items-center gap-x-1 rounded-md py-2 px-4 hover:bg-gray-100">
                <div className="relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="#000"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                  />
                </svg>
                <span className="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 p-2 text-xs text-white">
                    {favitem}
                  </span>
                  </div>
                <span className="text-sm font-medium hidden lg:block">Favorites</span>
                
              </Link>

              <div className="flex cursor-pointer items-center gap-x-1 rounded-md py-2 px-4 hover:bg-gray-100">
                <div className="relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="#000"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                    />
                  </svg>

                  {/* <span className="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 p-2 text-xs text-white">
                    0
                  </span> */}

                </div>

                <span className="text-sm font-medium hidden lg:block">Cart</span>
              </div>
              {isAuthenticated &&  <Link to='/myprofile' className="flex cursor-pointer items-center gap-x-1 rounded-md py-2 px-4 hover:bg-gray-100">
                <span className="text-sm font-medium hidden lg:block">Profile</span>
              </Link>}

              {isAuthenticated ? (
              <div className="ml-2 flex cursor-pointer items-center gap-x-1 rounded-md border py-2 px-4 hover:bg-gray-100">
                <span className="text-sm font-medium" onClick={() => logout()}>
                  Sign Out
                </span>
              </div>
                ) : (
              <div className="ml-2 flex cursor-pointer items-center gap-x-1 rounded-md border py-2 px-4 hover:bg-gray-100">
                <span
                  className="text-sm font-medium"
                  onClick={() => loginWithRedirect()}
                >
                  Sign in
                </span>
              </div>
                 )
                }



            </div>
          </div>
        </div>
      </div>
    
  );
};

export default Header;
